class ProductDescriptionTabs extends HTMLElement {
    constructor() {
        super();

        this.querySelectorAll('[data-description-tab-trigger]').forEach((trigger) => {
            trigger.addEventListener('click', this.onTriggerClick.bind(this));
        });

        this.querySelectorAll('[data-description-tab].is-open [data-description-tab-panel]').forEach((panel) => {
            panel.style.maxHeight = panel.scrollHeight + 'px';
        });
    }

    onTriggerClick(event) {
        const trigger = event.currentTarget;
        const item = trigger.closest('[data-description-tab]');
        const panel = item.querySelector('[data-description-tab-panel]');

        const isOpen = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : null;
    }
}

customElements.define('product-description-tabs', ProductDescriptionTabs);
